export default {
    title: '<strong>กิจกรรมคาบเรียนแบบเรียลไทม์</strong>ที่<strong>คุณครู</strong>และ<strong>นักเรียน</strong>ร่วมทำไปด้วยกัน',
    buttons: {
        teacher: 'คุณครูเริ่มสอน',
        student: 'นักเรียนเข้าร่วม',
    },
};
